import { useAnalytics, useMetrics, useObservabilityConfig, useProject, useReports } from "@sail/observability";
import { useCallback } from "react";
import useDataConfig from "../config/useDataConfig";
import { logHttpError } from "../telemetry/logHttp";
import loadId from "../../shared/loadId";
export default function useFetchLog() {
    var _useObservabilityConfig;
    const project = useProject();
    const service = (_useObservabilityConfig = useObservabilityConfig()) === null || _useObservabilityConfig === void 0 ? void 0 : _useObservabilityConfig.service;
    const errors = useReports();
    const metrics = useMetrics();
    const analytics = useAnalytics();
    const dataConfig = useDataConfig();
    const expectedErrorsFromDataConfig = dataConfig.observability.expectedErrors;
    return useCallback((res, duration, callSiteConfig)=>{
        const { headers, status, statusText, url } = res;
        const { expectedErrors: expectedErrorsFromCallSite } = callSiteConfig;
        const allExpectedErrors = expectedErrorsFromDataConfig.concat(expectedErrorsFromCallSite !== null && expectedErrorsFromCallSite !== void 0 ? expectedErrorsFromCallSite : []);
        const observabilityFns = {
            errors,
            metrics,
            analytics
        };
        const isExpected = allExpectedErrors.includes(status);
        var _headers_get;
        const reportParams = {
            service: service !== null && service !== void 0 ? service : '<unknown>',
            project: project !== null && project !== void 0 ? project : '<unknown>',
            errorCode: `HTTP ${status}`,
            errorMessage: statusText,
            errorPath: '',
            errorExpected: isExpected,
            // The GraphQL operation name, e.g. PaymentsFragment
            operationName: url,
            // Network information:
            networkDuration: duration,
            networkStatus: status,
            networkActionId: null,
            networkRequestId: (_headers_get = headers.get('Request-Id')) !== null && _headers_get !== void 0 ? _headers_get : null,
            networkTraceId: null,
            loadId
        };
        logHttpError('Fetch', observabilityFns, reportParams);
    }, [
        errors,
        expectedErrorsFromDataConfig,
        metrics,
        analytics,
        service,
        project
    ]);
}

//# sourceMappingURL=useFetchLog.js.map